// src/services/notifications.ts
import axiosInstance from "../axiosInstance";
import { ApiResponse } from "@/types/apiResponse";

// Server returns a discriminated union — personal in-app messages and
// admin-published announcements share the same feed but render differently.
export interface Notification {
  kind: "personal" | "announcement";
  notification_id: number | string | null;
  announcement_id: string | null;
  user_id: string | null;
  /** Present for announcements only; null for personal notifications. */
  title: string | null;
  message: string;
  action: string | null;
  path: string | null;
  is_read: boolean;
  created_at: string;
}

export const getNotifications = async (): Promise<ApiResponse<Notification[]>> => {
  const response = await axiosInstance.get("/notifications");
  return response.data;
};

export const markAllNotificationsAsRead = async (): Promise<ApiResponse<null>> => {
  const response = await axiosInstance.post("/notifications/mark-all-as-read");
  return response.data;
};

export const markAnnouncementAsRead = async (
  announcementId: string
): Promise<ApiResponse<null>> => {
  const response = await axiosInstance.post(
    `/notifications/announcements/${announcementId}/read`
  );
  return response.data;
};

/** Stable React key — IDs come from different columns by kind. */
export const notificationKey = (n: Notification): string =>
  n.kind === "announcement"
    ? `a-${n.announcement_id ?? "unknown"}`
    : `p-${n.notification_id ?? n.created_at}`;
